(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BPE-DIWALI-CLEARANCE"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grand-diwali-sale')) {
  customElements.define('grand-diwali-sale', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const controller = new AbortController();
      this.cleanupController = controller;
      const signal = controller.signal;
      const root = this;
      const motion = root.querySelector('.motion');
      const hero = root.querySelector('.hero');
      const canvas = root.querySelector('canvas');
      const ctx = canvas ? canvas.getContext('2d') : null;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches || root.dataset.animation !== 'true';
      let onscreen = true;
      let frameId = 0;
      let last = 0;
      let elapsed = 0;
      let particles = [];
      let rockets = [];
      let toastTimer;
      let purchasing = false;
      const toast = root.querySelector('.cart-toast');

      const tell = (message) => {
        toast.textContent = message;
        toast.classList.add('visible');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => toast.classList.remove('visible'), 2500);
      };

      const purchase = async (form, buy) => {
        if (purchasing) return;
        purchasing = true;
        const buttons = [...root.querySelectorAll('.add-button, .buy-button')];
        const disabledBefore = buttons.map(button => button.disabled);
        const activeButton = form.querySelector(buy ? '.buy-button .button-label' : '.add-button');
        const originalLabel = activeButton.textContent;
        const message = form.querySelector('.purchase-message');
        message.hidden = true;
        form.setAttribute('aria-busy', 'true');
        activeButton.textContent = root.dataset.busy;
        buttons.forEach(button => { button.disabled = true; });
        try {
          const response = await fetch(root.dataset.addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
            signal
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.error);
          if (buy) {
            window.location.assign(root.dataset.rootUrl + 'checkout');
            return;
          }
          tell(root.dataset.added);
          const count = root.querySelector('[data-count]');
          if (count) count.textContent = String((Number(count.textContent) || 0) + 1);
          try {
            const cartResponse = await fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, signal });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              if (count) count.textContent = String(cart.item_count);
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            }
          } catch (_) {}
        } catch (error) {
          if (error.name !== 'AbortError') {
            message.textContent = error.message || root.dataset.error;
            message.hidden = false;
          }
        } finally {
          purchasing = false;
          form.removeAttribute('aria-busy');
          activeButton.textContent = originalLabel;
          buttons.forEach((button, index) => { button.disabled = disabledBefore[index]; });
        }
      };

      root.querySelectorAll('.sale-purchase-form').forEach(form => {
        form.addEventListener('submit', event => {
          event.preventDefault();
          event.stopPropagation();
          purchase(form, false);
        }, { signal });
        form.querySelector('[data-buy]').addEventListener('click', () => purchase(form, true), { signal });
      });

      const size = () => {
        if (!canvas || !ctx) return;
        const rect = hero.getBoundingClientRect();
        const ratio = Math.min(devicePixelRatio || 1, 2);
        canvas.width = Math.round(rect.width * ratio);
        canvas.height = Math.round(rect.height * ratio);
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      };
      const burst = (x, y) => {
        for (let i = 0; i < 54; i++) {
          const angle = Math.PI * 2 * i / 54;
          const speed = 25 + Math.random() * 70;
          particles.push({ x, y, px: x, py: y, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed, life: 1.3 + Math.random() * .8, color: i % 5 === 0 ? '#f3dfc0' : i % 3 === 0 ? '#d78c55' : '#edc986' });
        }
      };
      const launch = () => {
        if (paused || reduced.matches || !ctx || rockets.length > 3) return;
        rockets.push({ x: hero.clientWidth * (.6 + Math.random() * .32), y: hero.clientHeight * .9, target: 50 + Math.random() * 80, trail: [] });
      };
      const running = () => !paused && !document.hidden && onscreen && !!ctx;
      const animate = (time) => {
        frameId = 0;
        if (!running()) return;
        const dt = last ? Math.min((time - last) / 1000, .04) : 0;
        last = time;
        ctx.clearRect(0, 0, hero.clientWidth, hero.clientHeight);
        elapsed += dt;
        if (elapsed > 5) { launch(); elapsed = 0; }
        for (let i = rockets.length - 1; i >= 0; i--) {
          const rocket = rockets[i];
          rocket.trail.push({ x: rocket.x, y: rocket.y });
          if (rocket.trail.length > 16) rocket.trail.shift();
          rocket.y -= 190 * dt;
          rocket.x += Math.sin(time / 200) * .15;
          for (let k = 1; k < rocket.trail.length; k++) {
            ctx.strokeStyle = '#edc986'; ctx.globalAlpha = k / rocket.trail.length * .55; ctx.lineWidth = 1.2;
            ctx.beginPath(); ctx.moveTo(rocket.trail[k - 1].x, rocket.trail[k - 1].y); ctx.lineTo(rocket.trail[k].x, rocket.trail[k].y); ctx.stroke();
          }
          if (rocket.y < rocket.target) { burst(rocket.x, rocket.y); rockets.splice(i, 1); }
        }
        particles = particles.filter(p => p.life > 0);
        for (const p of particles) {
          p.life -= dt; p.px = p.x; p.py = p.y; p.x += p.vx * dt; p.y += p.vy * dt; p.vy += 22 * dt; p.vx *= .995;
          ctx.globalAlpha = Math.max(0, Math.min(1, p.life)) * .7; ctx.strokeStyle = p.color; ctx.lineWidth = 1.2;
          ctx.beginPath(); ctx.moveTo(p.px, p.py); ctx.lineTo(p.x, p.y); ctx.stroke();
          ctx.fillStyle = p.color; ctx.beginPath(); ctx.arc(p.x, p.y, .9, 0, Math.PI * 2); ctx.fill();
        }
        frameId = requestAnimationFrame(animate);
      };
      const sync = () => {
        root.classList.toggle('paused', paused);
        motion.textContent = paused ? root.dataset.resume : root.dataset.pause;
        motion.setAttribute('aria-pressed', String(paused));
        if (running()) {
          if (!frameId) { last = 0; frameId = requestAnimationFrame(animate); }
        } else {
          cancelAnimationFrame(frameId); frameId = 0;
          if (ctx) ctx.clearRect(0, 0, hero.clientWidth, hero.clientHeight);
        }
      };
      motion.addEventListener('click', () => {
        if (reduced.matches || root.dataset.animation !== 'true') return;
        paused = !paused; sync();
      }, { signal });
      motion.hidden = root.dataset.animation !== 'true' || reduced.matches;
      reduced.addEventListener('change', event => {
        paused = event.matches || root.dataset.animation !== 'true';
        motion.hidden = root.dataset.animation !== 'true' || event.matches;
        sync();
      }, { signal });
      root.querySelector('[data-burst]').addEventListener('click', launch, { signal });
      document.addEventListener('visibilitychange', sync, { signal });
      const resize = new ResizeObserver(size); resize.observe(hero);
      const intersection = new IntersectionObserver(entries => { onscreen = entries[0].isIntersecting; sync(); });
      intersection.observe(hero);
      size(); sync();
      this.dispose = () => { cancelAnimationFrame(frameId); clearTimeout(toastTimer); resize.disconnect(); intersection.disconnect(); controller.abort(); };
    }
    disconnectedCallback() { if (this.dispose) this.dispose(); this.ready = false; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grand-diwali-sale"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('grand-diwali-sale')) {
customElements.define('grand-diwali-sale',class extends HTMLElement {
connectedCallback(){
 if(this.motionController)return;
 const controller=new AbortController();this.motionController=controller;const signal=controller.signal;
 const hero=this.querySelector('.gd-scene-hero'),frame=this.querySelector('.gd-scene-frame'),button=this.querySelector('.gd-scene-motion');if(!hero||!frame||!button)return;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');let paused=reduced.matches||this.dataset.animation!=='true';
 const sync=()=>{frame.contentWindow?.postMessage({type:'gd-motion',paused},'*');button.textContent=paused?this.dataset.resume:this.dataset.pause;button.setAttribute('aria-pressed',String(paused));button.disabled=reduced.matches||this.dataset.animation!=='true';};
 const fit=()=>this.style.setProperty('--gd-header-offset',Math.max(0,Math.round(hero.getBoundingClientRect().top+scrollY))+'px');
 button.addEventListener('click',()=>{paused=!paused;sync();},{signal});frame.addEventListener('load',sync,{signal});reduced.addEventListener('change',()=>{paused=reduced.matches;sync();},{signal});window.addEventListener('resize',fit,{signal});requestAnimationFrame(fit);sync();
}
disconnectedCallback(){this.motionController?.abort();this.motionController=null;}
});}

if (!customElements.get('grand-diwali-combo')) {
  customElements.define('grand-diwali-combo', class extends HTMLElement {
    connectedCallback() {
      if (this.comboReady) return;
      this.comboReady = true;
      const root = this;
      const controller = new AbortController();
      this.comboController = controller;
      const selects = Array.from(root.querySelectorAll('[data-combo-option]'));
      const whatsapp = root.querySelector('[data-combo-whatsapp]');
      const button = root.querySelector('[data-combo-add]');
      let busy = false;
      let modelsConfirmed = false;
      const message = root.querySelector('[data-combo-message]');
      const totalLabel = root.querySelector('[data-combo-total]');
      const compareLabel = root.querySelector('[data-combo-compare]');
      const savingsLabel = root.querySelector('[data-combo-savings]');
      const phone = (root.dataset.waPhone || '').replace(/[^0-9]/g, '');
      const validPhone = /^[1-9][0-9]{7,14}$/.test(phone);
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: root.dataset.currency || 'INR',minimumFractionDigits:0,maximumFractionDigits:2 });
      const format = cents => money.format(cents / 100);

      const render = () => {
        const options = selects.map(select => select.selectedOptions[0]).filter(Boolean);
        const complete = options.length === 3;
        button.disabled = busy || !complete || options.some(option => option.dataset.available !== 'true');
        let total = 0;
        let rangeMin = 0;
        let rangeMax = 0;
        let compare = 0;
        const lines = [];
        selects.forEach((select, index) => {
          const option = select.selectedOptions[0];
          if (!option) return;
          const price = Number(option.dataset.price) || 0;
          const reference = Math.max(price, Number(option.dataset.compare) || price);
          const card = select.closest('.gd-combo-card');
          const prices = Array.from(select.options, o => Number(o.dataset.price));
          const min = Math.min(...prices), max = Math.max(...prices);
          rangeMin += min; rangeMax += max;
          card.querySelector('[data-item-price]').textContent = min === max ? format(min) : format(min) + '–' + format(max);
          const previous = card.querySelector('[data-item-compare]');
          previous.textContent = format(reference);
          previous.hidden = select.options.length > 1 || reference <= price;
          const saving = card.querySelector('[data-item-saving]');
          saving.hidden = select.options.length > 1 || reference <= price;
          saving.textContent = root.dataset.savingLabel + ' ' + format(reference - price);
          total += price;
          compare += reference;
          const productLink = card.querySelector('h3 a');
          const variant = select.options.length > 1 ? ' — ' + option.dataset.title : '';
          lines.push((index + 1) + '. ' + productLink.textContent.trim() + variant + ' — ' + format(price) + '\n' + new URL(productLink.getAttribute('href'), window.location.origin).href);
        });
        totalLabel.textContent = complete ? !modelsConfirmed && rangeMin !== rangeMax ? format(rangeMin) + '–' + format(rangeMax) : format(total) : '—';
        compareLabel.textContent = format(compare);
        compareLabel.hidden = !complete || (!modelsConfirmed && rangeMin !== rangeMax) || compare <= total;
        savingsLabel.hidden = !complete || (!modelsConfirmed && rangeMin !== rangeMax) || compare <= total;
        savingsLabel.textContent = root.dataset.savingLabel + ' ' + format(compare - total);
        whatsapp.hidden = !complete || !validPhone;
        if (complete && validPhone) {
          const text = [root.dataset.waIntro, '', ...lines, '', root.dataset.waTotal + ' ' + format(total), root.dataset.waQuestion].join('\n');
          whatsapp.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(text);
        } else {
          whatsapp.removeAttribute('href');
        }
        if (!busy) message.textContent = complete ? '' : root.dataset.missing;
      };
      selects.forEach(select => select.addEventListener('change', render, { signal: controller.signal }));
      const label = button.textContent;
      const picker = document.createElement('dialog');
      picker.className = 'gd-combo-picker';
      picker.setAttribute('aria-label','Choose combo models');
      root.append(picker);
      const openPicker = () => {
        picker.replaceChildren();
        const heading = document.createElement('h2'); heading.textContent = 'Choose your combo models'; picker.append(heading);
        const close = document.createElement('button'); close.type = 'button'; close.className = 'gd-combo-picker-close'; close.textContent = '×'; close.setAttribute('aria-label','Close combo model selection');
        close.addEventListener('click',()=>picker.close()); picker.append(close);
        const fields = [];
        selects.forEach(select => {
          const label = document.createElement('label');
          label.textContent = select.closest('.gd-combo-card').querySelector('h3').textContent.trim();
          const field = select.cloneNode(true); field.hidden = select.options.length === 1; field.removeAttribute('id'); field.removeAttribute('data-combo-option');
          label.append(field);
          if (field.hidden) {
            const fixed = document.createElement('span'); fixed.className = 'gd-combo-fixed-model';
            const option = field.selectedOptions[0];
            fixed.textContent = (option.dataset.title === 'Default Title' ? '' : option.dataset.title + ' — ') + format(Number(option.dataset.price)); label.append(fixed);
          }
          picker.append(label); fields.push(field);
        });
        const total = document.createElement('p'); picker.append(total);
        const confirm = document.createElement('button'); confirm.type = 'button'; confirm.className = 'gd-combo-picker-confirm'; confirm.textContent = 'Add all 3 to cart'; picker.append(confirm);
        const update = () => { total.textContent = 'Selected total: ' + format(fields.reduce((sum,f)=>sum+Number(f.selectedOptions[0].dataset.price),0)); confirm.disabled = fields.some(f=>f.selectedOptions[0].dataset.available !== 'true'); };
        fields.forEach(f=>f.addEventListener('change',update));
        confirm.addEventListener('click',()=>{
          fields.forEach((f,i)=>{selects[i].value=f.value;}); modelsConfirmed=true; render(); picker.close(); button.click();
        });
        update(); picker.showModal();
      };
      picker.addEventListener('close',()=>button.focus({preventScroll:true}));
      window.addEventListener('pageshow',()=>{ if(picker.open)picker.close(); busy=false; modelsConfirmed=false; button.textContent=label; selects.forEach(s=>s.disabled=false); root.removeAttribute('aria-busy'); render(); },{signal:controller.signal});

      button.addEventListener('click', async () => {
        if (!busy && !modelsConfirmed && selects.some(s=>s.options.length>1)) { openPicker(); return; }
        const options = selects.map(select => select.selectedOptions[0]).filter(Boolean);
        if (busy || options.length !== 3 || options.some(option => option.dataset.available !== 'true')) return;
        const quantities = new Map();
        options.forEach(option => quantities.set(option.value, (quantities.get(option.value) || 0) + 1));
        const items = Array.from(quantities, ([id, quantity]) => ({id, quantity}));
        busy = true; button.disabled = true;
        button.textContent = root.dataset.adding;
        root.setAttribute('aria-busy', 'true');
        selects.forEach(select => { select.disabled = true; });
        message.textContent = '';
        try {
          const response = await fetch(root.dataset.addUrl, {
            method: 'POST', headers: {'Content-Type':'application/json', Accept:'application/json'},
            body: JSON.stringify({items,sections:['cart-drawer','cart-icon-bubble','cart-notification-product','cart-notification-button'],sections_url:window.location.pathname}), signal: controller.signal
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.cartError);
          const drawer = document.querySelector('cart-drawer');
          const notification = document.querySelector('cart-notification');
          if (drawer && result.sections?.['cart-drawer'] && result.sections?.['cart-icon-bubble']) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(result,false);
          }
          if (window.matchMedia('(min-width:750px)').matches && notification && result.sections?.['cart-notification-product'] && result.sections?.['cart-notification-button']) {
            notification.setActiveElement(button);
            notification.renderContents({...result,key:result.items[0].key});
            const host = notification.querySelector('#cart-notification-product');
            const parsed = new DOMParser().parseFromString(result.sections['cart-notification-product'],'text/html');
            const rows = result.items.map(item => {
              const source = parsed.getElementById('cart-notification-product-' + item.key);
              if (!source) return null;
              const row = document.createElement('div');
              row.className = 'gd-combo-notification-row';
              row.innerHTML = source.innerHTML;
              return row;
            }).filter(Boolean);
            if (rows.length) { host.classList.add('gd-combo-notification'); host.replaceChildren(...rows); }
          } else if (drawer) {
            notification?.close();
            drawer.open(button);
          }
        } catch (error) {
          if (error.name !== 'AbortError') message.textContent = error.message || root.dataset.cartError;
        } finally {
          busy = false; modelsConfirmed = false; button.textContent = label; root.removeAttribute('aria-busy');
          selects.forEach(select => { select.disabled = false; });
          button.disabled = options.length !== 3 || options.some(option => option.dataset.available !== 'true');
        }
      }, {signal: controller.signal});
      render();
    }
    disconnectedCallback() { this.comboController?.abort(); this.comboReady = false; }
  });
}


if (!customElements.get('diwali-product-actions')) {
  customElements.define('diwali-product-actions', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const dialog = this.querySelector('.gd-model-dialog');
      const confirm = dialog.querySelector('[data-model-confirm]');
      const close = dialog.querySelector('[data-model-close]');
      const optionsHost = dialog.querySelector('[data-model-options]');
      const states = [];
      let active = null;
      let choice = null;
      let trigger = null;
      const plain = html => { const span = document.createElement('span'); span.innerHTML = html; return span.textContent; };
      const showModel = () => {
        if (!active || !choice) return;
        active.select.value = choice.value;
        const option = active.select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        dialog.querySelector('[data-model-price]').innerHTML = option.dataset.price;
        const compare = dialog.querySelector('[data-model-compare]');
        compare.innerHTML = option.dataset.compare;
        compare.hidden = !(Number(option.dataset.discount) > 0);
        const discount = dialog.querySelector('[data-model-discount]');
        discount.textContent = option.dataset.discount + '% OFF';
        discount.hidden = !(Number(option.dataset.discount) > 0);
        const card = active.form.closest('.sale-product');
        const cardDiscount = card.querySelector('[data-card-discount]');
        const stamp = card.querySelector('.offer-stamp');
        cardDiscount.textContent = option.dataset.discount;
        stamp.hidden = !(Number(option.dataset.discount) > 0);
        stamp.setAttribute('aria-label', option.textContent + ': ' + option.dataset.discount + '% OFF');
        dialog.querySelector('[data-model-stock]').hidden = available;
        confirm.disabled = active.busy || !available;
        confirm.textContent = available ? trigger.dataset.purchase === 'buy' ? 'Buy Now' : 'Add to cart' : active.select.dataset.soldOut;
        confirm.removeAttribute('title'); confirm.removeAttribute('aria-label'); confirm.removeAttribute('data-loading');
      };
      const closeDialog = () => { if (!active?.busy && dialog.open) dialog.close(); };
      close.addEventListener('click', closeDialog, {signal});
      dialog.addEventListener('cancel', event => { if (active?.busy) event.preventDefault(); }, {signal});
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog();
      }, {signal});
      dialog.addEventListener('close', () => {
        const opener = trigger;
        optionsHost.replaceChildren(); choice = null; active = null; trigger = null;
        if (opener?.isConnected) opener.focus({preventScroll:true});
      }, {signal});
      confirm.addEventListener('click', () => { if (active && !confirm.disabled) active.purchase(trigger); }, {signal});
      const openModel = (state, button) => {
        if (dialog.open) return;
        active = state; trigger = button;
        dialog.querySelector('[data-model-product]').textContent = state.form.closest('article').querySelector('h3').textContent.trim();
        const label = document.createElement('label');
        choice = state.select.cloneNode(true);
        choice.removeAttribute('name'); choice.removeAttribute('data-card-variant');
        choice.id = 'ModelChoice-' + state.form.id;
        choice.disabled = false;
        label.htmlFor = choice.id;
        label.textContent = state.form.querySelector('label').textContent;
        Array.from(choice.options).forEach((option, index) => { option.textContent = state.select.options[index].textContent.trim() + ' — ' + plain(option.dataset.price); });
        choice.value = state.select.value;
        optionsHost.replaceChildren(label, choice);
        choice.addEventListener('change', showModel, {signal});
        close.disabled = false; showModel();
        dialog.showModal(); choice.focus();
      };
      this.querySelectorAll('.gd-product-purchase').forEach(form => {
        const buttons = Array.from(form.querySelectorAll('button'));
        const select = form.querySelector('[data-card-variant]');
        const originals = buttons.map(button => ({button,label:button.textContent,disabled:button.disabled}));
        const state = {form,select,busy:false,purchase:null,reset:null,feedbackTimer:null};
        signal.addEventListener('abort', () => clearTimeout(state.feedbackTimer), {once:true});
        state.reset = () => {
          clearTimeout(state.feedbackTimer);
          state.busy = false; form.removeAttribute('aria-busy');
          originals.forEach(({button,label,disabled}) => {
            button.disabled = disabled; button.textContent = label;
            button.removeAttribute('data-loading'); button.removeAttribute('aria-label'); button.removeAttribute('title');
          });
          if (active === state) { choice.disabled = false; close.disabled = false; showModel(); }
        };
        state.purchase = async button => {
          if (state.busy || !button || button.disabled) return;
          if (select && select.selectedOptions[0]?.dataset.available !== 'true') return;
          const buy = button.dataset.purchase === 'buy';
          state.busy = true; buttons.forEach(item => { item.disabled = true; });
          form.setAttribute('aria-busy','true');
          button.setAttribute('data-loading','true'); button.textContent = buy ? 'Opening…' : 'Adding…';
          button.setAttribute('aria-label',buy ? 'Opening checkout for this model only' : 'Adding item to cart');
          if (active === state) {
            choice.disabled = true; close.disabled = true; confirm.disabled = true;
            confirm.textContent = buy ? 'Opening…' : 'Adding…'; confirm.setAttribute('data-loading','true');
          }
          const request = new AbortController();
          const abort = () => request.abort();
          signal.addEventListener('abort', abort, {once:true});
          const timer = setTimeout(abort,15000);
          try {
            const variantId = form.querySelector('[name="id"]').value;
            let destination = this.dataset.cartUrl;
            if (buy) {
              const merchandiseId = `gid://shopify/ProductVariant/${variantId}`;
              const response = await fetch(this.dataset.storefrontUrl, {
                method:'POST', credentials:'omit',
                headers:{'Content-Type':'application/json',Accept:'application/json'},
                body:JSON.stringify({
                  query:'mutation DiwaliBuyNow($input: CartInput!, $country: CountryCode!) @inContext(country: $country) { cartCreate(input: $input) { cart { checkoutUrl totalQuantity lines(first: 2) { nodes { quantity merchandise { ... on ProductVariant { id } } } } } userErrors { message } } }',
                  variables:{country:this.dataset.country,input:{lines:[{merchandiseId,quantity:1}],buyerIdentity:{countryCode:this.dataset.country}}}
                }),signal:request.signal
              });
              const result = await response.json();
              const payload = result.data?.cartCreate;
              if (!response.ok || result.errors?.length || payload?.userErrors?.length) {
                throw new Error(payload?.userErrors?.[0]?.message || 'Unable to open checkout. Please try again.');
              }
              const cart = payload?.cart;
              const lines = cart?.lines?.nodes;
              if (cart?.totalQuantity !== 1 || lines?.length !== 1 || lines[0].quantity !== 1 || lines[0].merchandise?.id !== merchandiseId || !cart.checkoutUrl) {
                throw new Error('This model is unavailable. Please choose another model.');
              }
              const checkout = new URL(cart.checkoutUrl);
              if (checkout.protocol !== 'https:') throw new Error('Unable to open checkout. Please try again.');
              destination = checkout.href;
            } else {
              const response = await fetch(this.dataset.addUrl, {
                method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
                body:JSON.stringify({items:[{id:variantId,quantity:1}],sections:['cart-drawer','cart-icon-bubble','cart-notification-product','cart-notification-button'],sections_url:window.location.pathname}),signal:request.signal
              });
              const result = await response.json();
              if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
              const drawer = document.querySelector('cart-drawer');
              if (drawer && result.sections?.['cart-drawer'] && result.sections?.['cart-icon-bubble']) {
                drawer.classList.remove('is-empty');
                drawer.renderContents(result, false);
                state.cartResponse = result;
              }
            }
            button.removeAttribute('data-loading'); button.textContent = buy ? 'Opening…' : 'Added ✓';
            if (active === state) { confirm.removeAttribute('data-loading'); confirm.textContent = button.textContent; }
            if (buy) {
              window.location.assign(destination);
            } else {
              if (active === state && dialog.open) {
                state.busy = false;
                dialog.close();
              }
              const notification = document.querySelector('cart-notification');
              const drawer = document.querySelector('cart-drawer');
              const added = state.cartResponse;
              if (added) requestAnimationFrame(() => {
                if (signal.aborted) return;
                if (window.matchMedia('(min-width: 750px)').matches && notification && added.sections?.['cart-notification-product'] && added.sections?.['cart-notification-button']) {
                  notification.setActiveElement(button);
                  notification.querySelector('#cart-notification-product').classList.remove('gd-combo-notification');
                  notification.renderContents({...added,key:added.items?.[0]?.key || added.key});
                  const name = notification.querySelector('.cart-notification-product__name');
                  if (name) name.textContent = name.textContent.replace(/\bBP-/g,'BP\u2011');
                } else if (drawer) {
                  notification?.close();
                  drawer.open(button);
                }
              });
              button.setAttribute('aria-label','Added to cart');
              if (active === state) confirm.setAttribute('aria-label','Added to cart');
              state.feedbackTimer = setTimeout(() => {
                if (signal.aborted) return;
                state.reset();
                if (active === state && dialog.open) dialog.close();
              }, 1600);
            }
          } catch(error) {
            state.reset();
            if (!signal.aborted) {
              const detail = error.name === 'AbortError' ? 'Request timed out. Please try again.' : error.message || this.dataset.error;
              const feedback = active === state ? confirm : button;
              feedback.textContent = 'Try again'; feedback.setAttribute('title',detail); feedback.setAttribute('aria-label',detail + '. Try again');
            }
          } finally { clearTimeout(timer); signal.removeEventListener('abort',abort); }
        };
        buttons.forEach(button => {
          button.setAttribute('aria-live','polite');
          if (select) button.setAttribute('aria-haspopup','dialog');
        });
        form.addEventListener('submit', event => {
          event.preventDefault();
          const button = event.submitter || buttons[0];
          if (state.busy || !button || button.disabled) return;
          if (select) openModel(state,button); else state.purchase(button);
        }, {signal});
        states.push(state);
      });
      window.addEventListener('pageshow', () => requestAnimationFrame(() => {
        states.forEach(state => state.reset());
        if (dialog.open) dialog.close();
      }), {signal});
    }
    disconnectedCallback(){
      this.controller?.abort(); this.controller=null;
      const dialog=this.querySelector('.gd-model-dialog'); if(dialog?.open) dialog.close();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }
  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
